import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"ma-4"},'div',_vm.$attrs,false),[_c(VRow,{attrs:{"no-gutters":"","align":"center"}},[_c(VCol,{staticClass:"shrink",attrs:{"cols":"1"}},[_c(VIcon,{attrs:{"color":_vm.color}},[_vm._v("mdi-check-circle-outline")])],1),_c(VCol,{staticClass:"ml-2"},[_c('h3',{staticClass:"font-weight-regular"},[_vm._t("default")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }